import React from 'react';
import PropTypes from 'prop-types';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  [key: string]: any;
}

const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  onClick, 
  className = '', 
  disabled = false, 
  type = 'button', 
  ...props 
}) => {
  // Define styles for different variants
  const baseStyles = `py-2 px-4 font-semibold rounded-lg transition-all duration-300 focus:outline-none `;
  const variantStyles: { [key: string]: string } = {
    primary: `bg-gradient-to-r from-yellow-500 to-yellow-800 text-white hover:from-yellow-600 hover:to-yellow-900 hover:shadow-xl`,
    secondary: `bg-red-500 text-white border-2 border-red-500 hover:bg-red-700 hover:border-red-700`,
    outline: `bg-transparent text-red-500 border-2 border-red-500 hover:bg-red-700 hover:text-white`,
    disabled: `bg-gray-300 text-gray-500 cursor-not-allowed`,
  };

  // Ensure the correct variant is applied
  const buttonVariant = disabled ? 'disabled' : variant;
  const buttonStyles = `${baseStyles} ${variantStyles[buttonVariant]} ${className}`;
  return (
    <button 
      type={type} 
      onClick={onClick} 
      className={buttonStyles} 
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

// PropTypes for better type checking
Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'outline']),
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

export default Button;
